export interface SectorRegistryEntry {
  slug: string;
  icon?: string;
  title: { fr: string; en: string };
  cardDescription: { fr: string; en: string };
  cardImage: string;
  teaser: { fr: string; en: string };
}

export const sectors: Record<string, SectorRegistryEntry> = {
  education: {
    slug: 'education',
    icon: '🎓',
    title: { fr: 'Éducation & EdTech', en: 'Education & EdTech' },
    cardDescription: {
      fr: 'Plateformes éducatives, LMS et outils pédagogiques pour organismes de formation.',
      en: 'Educational platforms, LMS and learning tools for training organizations.',
    },
    cardImage: 'https://placehold.co/800x600/0f2137/b98745?text=EdTech',
    teaser: { fr: 'EdTech & Qualiopi', en: 'EdTech & Qualiopi' },
  },
  'agile-delivery': {
    slug: 'agile-delivery',
    icon: '🎯',
    title: { fr: 'Delivery Agile & Pilotage', en: 'Agile Delivery & Steering' },
    cardDescription: {
      fr: 'Pilotage de projet, delivery management et transparence opérationnelle.',
      en: 'Project steering, delivery management and operational transparency.',
    },
    cardImage: 'https://placehold.co/800x600/0d2842/b98745?text=Agility+%26+Coaching',
    teaser: { fr: 'Delivery & agile', en: 'Delivery & agile' },
  },
  biology: {
    slug: 'biology',
    icon: '🧬',
    title: { fr: 'Biologie & Life Sciences', en: 'Biology & Life Sciences' },
    cardDescription: {
      fr: 'Outils bio-informatiques et pipelines de données pour laboratoires.',
      en: 'Bioinformatics tools and data pipelines for laboratories.',
    },
    cardImage: 'https://placehold.co/800x600/0f2137/b98745?text=Biology+%26+Pharma',
    teaser: { fr: 'R&D, data & pipelines', en: 'R&D, data & pipelines' },
  },
  pharmaceutics: {
    slug: 'pharmaceutics',
    icon: '💊',
    title: { fr: 'Pharmaceutique & Santé', en: 'Pharmaceutical & Health' },
    cardDescription: {
      fr: 'Qualité, traçabilité et conformité GMP pour l’industrie pharmaceutique.',
      en: 'Quality, traceability and GMP compliance for the pharmaceutical industry.',
    },
    cardImage: 'https://placehold.co/800x600/1d6fb8/ffffff?text=Pharmaceutique',
    teaser: { fr: 'QMS, GMP & traçabilité', en: 'QMS, GMP & traceability' },
  },
  logistics: {
    slug: 'logistics',
    icon: '📦',
    title: { fr: 'Logistique & Supply Chain', en: 'Logistics & Supply Chain' },
    cardDescription: {
      fr: 'WMS, suivi des flux et optimisation supply chain.',
      en: 'WMS, flow tracking and supply chain optimization.',
    },
    cardImage: 'https://placehold.co/800x600/1d6fb8/ffffff?text=Logistics',
    teaser: { fr: 'Supply chain & WMS', en: 'Supply chain & WMS' },
  },
};

export const sectorSlugs = Object.keys(sectors);

/* Legacy types kept for reference; page content has moved to dictionaries. */
export type SectorMvp = {
  title: string;
  description: string;
  prompt: string;
};

export type SectorBiography = {
  eyebrow: string;
  title: string;
  photo: string;
  photoAlt: string;
  paragraphs: string[];
};

export type SectorContext = {
  title: string;
  description: string;
};

export type SectorData = {
  slug: string;
  icon?: string;
  title: { fr: string; en: string };
  cardDescription?: { fr: string; en: string };
  cardImage?: string;
  heroBackgroundImage?: string;
  teaser?: { fr: string; en: string };
  seoTitle: { fr: string; en: string };
  seoDescription: { fr: string; en: string };
  heroTitle: { fr: string; en: string };
  heroHighlight: { fr: string; en: string };
  heroDescription: { fr: string; en: string };
  background?: { fr: string; en: string };
  biography?: { fr: SectorBiography; en: SectorBiography };
  clients?: { fr: string[]; en: string[] };
  specifics?: { fr: string[]; en: string[] };
  mvps?: { fr: SectorMvp[]; en: SectorMvp[] };
  northStarSectorId?: string;
  painPoints: { fr: string[]; en: string[] };
  solutions: { fr: string[]; en: string[] };
  useCases: { fr: SectorContext[]; en: SectorContext[] };
  keywords: { fr: string[]; en: string[] };
};
